import { useNavigate } from "react-router-dom";
import Button from "@/components/common/Button";
import WebIcon from "@/components/common/Web_Icons";

const EmptyState = () => {
  const navigate = useNavigate();

  const handleSetupClick = () => {
    navigate("/dashboard/manifesto/add");
  };

  return (
    <div className="flex flex-col items-center justify-center rounded-lg p-8 mt-6 max-w-[600px] mx-auto">
      <WebIcon
        icon="ManifestoHover"
        size="large"
        className="mb-6 w-[100px] h-[100px]"
      />
      <h2 className="mb-4 heading-large whitespace-nowrap font-bold text-lighterGrey">
        Manifesto Empty
      </h2>
      <p className="mb-8 font-normal text-bold-x text-lighterGrey">
        There&apos;s nothing to show here.
      </p>
      <Button
        text="CREATE NEW MANIFESTO"
        color="primary"
        className="w-full px-6 py-3 font-medium text-white"
        customBgColor="primary"
        customTextColor="white"
        onClick={handleSetupClick}
      />
    </div>
  );
};

export default EmptyState;
